module.exports = __webpack_public_path__ + "img/boat-launch.138b92e4.svg";